import { render } from "./ConversationHistoryVoice.vue?vue&type=template&id=578a3f66&scoped=true"
import script from "./ConversationHistoryVoice.vue?vue&type=script&lang=js"
export * from "./ConversationHistoryVoice.vue?vue&type=script&lang=js"

import "./ConversationHistoryVoice.vue?vue&type=style&index=0&id=578a3f66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578a3f66"]])

export default __exports__